import React from 'react';
import getColor from '../utils/interpolateColor';

const BG_GREY = '#e8eaea';

const CircleProgressChart = ({
  name,
  score,
  originalSize = 280,
  originalRadius = 96,
  strokeWidth = 16,
  reductionFactor = 1,
  mtop = 0,
  mbottom = 10,
  strokeClr = BG_GREY,
  t,
}) => {
  const circleSize = originalSize * reductionFactor;
  const circleRadius = originalRadius * reductionFactor;
  const center = circleSize / 2;
  const r = circleRadius - strokeWidth / 2;
  const circumference = 2 * Math.PI * r;
  const clamped = Math.max(0, Math.min(100, Number(score) ?? 0));
  const strokeDashoffset =
    clamped === 100
      ? 0
      : circumference - (clamped / 100) * circumference;
  const primeColor = getColor(clamped);

  return (
    <div
      className="relative flex justify-center items-center"
      style={{
        height: circleSize,
        width: circleSize,
        marginTop: mtop || 0,
        marginBottom: mbottom || 0,
      }}
    >
      <svg
        width={circleSize}
        height={circleSize}
        viewBox={`0 0 ${circleSize} ${circleSize}`}
        className="absolute"
      >
        <circle
          cx={center}
          cy={center}
          r={r}
          fill="none"
          stroke={strokeClr}
          strokeWidth={strokeWidth}
        />
        <circle
          cx={center}
          cy={center}
          r={r}
          fill="none"
          stroke={clamped > 0 ? primeColor : 'none'}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          style={{
            transform: 'rotate(-90deg)',
            transformOrigin: 'center',
            transition: 'stroke-dashoffset 0.6s ease 0s',
          }}
        />
      </svg>
      <div
        className="absolute inset-0 flex flex-col justify-center items-center text-center"
        style={{ lineHeight: 1, fontWeight: 'bold' }}
      >
        <span style={{ fontSize: '2rem', fontWeight: 800 }}>{clamped}</span>
        <span style={{ display: 'block', fontSize: '0.75rem' }}>{t ? t('POÄNG') : 'POÄNG'}</span>
      </div>
    </div>
  );
};

export default CircleProgressChart;
